/*
 * Breakpoint definitions via CSS Custom Media (postcss-custom-media).
 *
 * DO NOT @import this file — it is automatically prepended to every compiled
 * Less module by the inject-custom-media-defs plugin in postcss.config.js.
 * Importing it manually would emit raw @custom-media rules into the bundle
 * instead of resolving them.
 *
 * Usage in .less files:  @media (--tablet) { ... }
 */
@custom-media --ultramobile only screen and (max-width: 430px);
@custom-media --mobile only screen and (max-width: 751px);
@custom-media --tablet only screen and (min-width: 752px) and (max-width: 1039px);
@custom-media --desktop only screen and (min-width: 1040px) and (max-width: 1327px);
@custom-media --widescreen only screen and (min-width: 1328px) and (max-width: 1615px);
@custom-media --ultrawide only screen and (min-width: 1616px);
@custom-media --tablet-height only screen and (max-height: 800px);
@custom-media --desktop-height only screen and (min-height: 801px);
